import {Helmet} from '@dr.pogodin/react-helmet';
import {BreadcrumbType} from 'platform/components';

import i18n from '@dms/i18n';
import {settingsRoutes} from '@dms/routes';
import {SettingsTemplate} from '@dms/settings/shared';
import {formatDocumentTitle} from '@dms/shared';

import {CebiaEquipmentAuthentication} from './components/CebiaEquipmentAuthentication';

export function Features() {
  const breadcrumbs: BreadcrumbType[] = [
    {
      label: i18n.t('page.integrations.labels.vehicleServices'),
      href: settingsRoutes.vehicleServices,
    },
  ];

  return (
    <>
      <Helmet
        title={formatDocumentTitle(
          i18n.t('page.integrations.labels.cebiaEquipment'),
          i18n.t('page.integrations.labels.vehicleServices'),
          i18n.t('page.settings.labels.title')
        )}
      />
      <SettingsTemplate
        header={{title: i18n.t('page.integrations.labels.cebiaEquipment'), breadcrumbs}}
        data-testid="integrations-cebia-equipment-settings"
      >
        <CebiaEquipmentAuthentication />
      </SettingsTemplate>
    </>
  );
}
